export const SET_LEARNING_PATH = (state, payload) => {
    state.learningPath = payload
}

export const SET_AGGREGATE_PATH = (state, payload) => {
    state.aggregatePath = payload
}

export default {
    SET_LEARNING_PATH,
    SET_AGGREGATE_PATH,
}
